import Aos from '../components/aos'
import React from "react"
import { createRoot } from "react-dom/client";
import MobileSlider from "../components/Sliders/MobileSlider"
import videoPlayer from '../components/videoPlayer';


/**
 * Front Page
 */
const PageFordsMedia = ($) =>{

	if ( $( 'body' ).hasClass( 'single-fords_media' ) ) {
		Aos();
		MobileSlider($);
		Aos();
		videoPlayer($);
	}
};

export default PageFordsMedia;
